import {apiClient} from 'core/apiClient';
import {CustomsAuditLogParams, CustomsAuditLogPage, CustomsAuditItem} from 'types/customs-audit';

const URL = '/customs/events';

export async function fetchCustomsAuditLog(params: CustomsAuditLogParams) {
    return (await apiClient.post<CustomsAuditLogPage>(`${URL}/list`, params)).data;
}

export async function exportCustomsAuditLog(
    params: CustomsAuditLogParams,
    format: 'CSV' | 'EXCEL',
) {
    return (
        await apiClient.post<Blob>(`${URL}/export`, params, {
            params: {format},
            responseType: 'blob',
        })
    ).data;
}

export async function fetchCustomsAuditLogById(eventId: string) {
    return (await apiClient.get<CustomsAuditItem>(`${URL}/${eventId}`)).data;
}

export async function exportCustomsAuditEvent(eventId: string) {
    return (await apiClient.get<Blob>(`${URL}/${eventId}/export`, {responseType: 'blob'})).data;
}
